import { render, staticRenderFns } from "./Spiner.vue?vue&type=template&id=3e9231aa&"
import script from "./Spiner.vue?vue&type=script&lang=ts&"
export * from "./Spiner.vue?vue&type=script&lang=ts&"
import style0 from "./Spiner.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports